<div class="item" [id]="pack.omapiId">
  <div #carouselImageWrapper
       class="product-item"
       [ngClass]="{'active-item': active}">
  </div>

  <div class="product-data">

    <app-badge *ngIf="showStreamzPromoBadge" [addTopSpacer]="isBigTile"
               [badgeCopy]="'eos-tv-shop-ii.lbl.streamz-promo.badge'"
               [showStreamzPromoBadge]="showStreamzPromoBadge">
    </app-badge>

    <div class="product-logo--container">
      <img *ngIf="!isRedCarpetOrRedCarpetMore()"
           [class.logo--size--1]="isSizeOneClassNeeded"
           class="product-logo"
           src="{{logoUrl}}"/>

      <div *ngIf="showSubtitle" class="subtitle" [translate]="'eos-tv-shop-ii.lbl.carousel-subtitle.' + pack.omapiId.toLowerCase()"></div>
    </div>

    <div class="price" *ngIf="!pack?.subscribed && !isTrialProduct">
      <div *ngIf="!(pack.isGroupPack && pack.subscribed)">
        <span *ngIf="pack.isGroupPack" class="price-padding" [translate]="'eos-tv-shop-ii.lbl.price-starting-from'"></span>
        <span *ngIf="hasPromo" class="promo-original-price">
          <ng-container *ngIf="currentLang !== 'fr'" class="currency">€</ng-container>
          <span>{{textIntegerPart}}{{textDecimalPart}}</span>
          <ng-container *ngIf="currentLang === 'fr'" class="currency left">€</ng-container>
        </span>
        <span *ngIf="currentLang !== 'fr'" class="currency">€</span>
        <span class="price-line">
          <span class="left">{{promoTextIntegerPrice}}</span>
          <span class="right">{{promoTextDecimalPart}}</span>
        </span>
        <span *ngIf="currentLang === 'fr'" class="currency left">€</span>
        <span class="month">/<span [translate]="'eos-tv-shop-ii.lbl.price-month'"></span></span>
        <br/>
        <span *ngIf="promoLabel"
              class="promo-label"
              [translate]="'eos-tv-shop-ii.lbl.' + promoLabel"
              [translateParams]="{ duration: promoDuration }">
          gedurende x maanden
        </span>
      </div>
      <span *ngIf="pack.isStreamingBundle && !showPromoBadge"
            class="promo-label"
            [translate]="'eos-tv-shop-ii.lbl.bundle-promo.' + pack.omapiId">
      </span>
      <app-badge *ngIf="pack.isStreamingBundle && showPromoBadge" [addTopSpacer]="isBigTile"
                 [badgeCopy]="'eos-tv-shop-ii.lbl.bundle-promo.' + pack.omapiId.toLowerCase() | translate:{promoPrice: 3.45}"></app-badge>
    </div>


    <div *ngIf="isTrialProduct" class="verzilveren price">
      <span [translate]="'eos-tv-shop-ii.title.code-verzilveren'">Code verzilveren</span>
    </div>
    <div [ngClass]="{'already-own': !(pack.isGroupPack && pack.subscribed)}" class="line-separator price" *ngIf="pack.subscribed">
      <div *ngIf="(pack.isGroupPack && pack.subscribed)">
        <span [translate]="'eos-tv-shop-ii.btn.netflix-standalone-choose-variant'">
        </span>
      </div>
      <div *ngIf="!(pack.isGroupPack && pack.subscribed)" class="icon-check" [translate]="'eos-tv-shop-ii.title.homepage-carousel-in-your-package'">
      </div>
    </div>
  </div>
</div>
